/* ── TSF Theme JS ──────────────────────────────────────────────────────────
   No framework. No aggressive reinit. Everything explicit.
─────────────────────────────────────────────────────────────────────────── */

/* ── Product Gallery ─────────────────────────────────────────────────────── */
function initGalleries() {
  document.querySelectorAll('.tsf-gallery').forEach(function (gallery) {
    var pid     = gallery.dataset.productId;
    var heroImg = gallery.querySelector('.tsf-gallery__hero');
    if (!heroImg) return;

    // Thumbnail click → update hero
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.tsf-gallery__thumb');
      if (!thumb || thumb.hidden) return;
      setActiveThumb(gallery, heroImg, thumb);
    });

    // Hero click → lightbox
    heroImg.style.cursor = 'zoom-in';
    heroImg.addEventListener('click', function () {
      openLightbox(heroImg.src, heroImg.alt);
    });

    // Colour change → filter gallery
    document.addEventListener('colour:change', function (e) {
      if (String(e.detail.productId) !== String(pid)) return;
      filterGallery(gallery, heroImg, e.detail.colour);
    });
  });
}

function setActiveThumb(gallery, heroImg, thumb) {
  gallery.querySelectorAll('.tsf-gallery__thumb').forEach(function (t) {
    t.classList.toggle('tsf-gallery__thumb--active', t === thumb);
  });
  heroImg.src = thumb.dataset.src;
  heroImg.alt = thumb.dataset.alt || '';
}

function filterGallery(gallery, heroImg, colour) {
  var thumbs    = Array.from(gallery.querySelectorAll('.tsf-gallery__thumb'));
  var altSideRe = /back|left|right|side/i;
  var hasOwn    = thumbs.some(function (t) { return t.dataset.colour === colour; });

  thumbs.forEach(function (t) {
    var c = t.dataset.colour || '';
    t.hidden = hasOwn ? (c !== colour) : (c !== '' && c !== colour);
  });

  var hero = thumbs.find(function (t) {
    if (t.dataset.colour !== colour) return false;
    return !altSideRe.test(t.dataset.alt || '');
  }) || thumbs.find(function (t) {
    return t.dataset.colour === colour && t.dataset.isBack !== 'true';
  }) || thumbs.find(function (t) {
    return t.dataset.colour === colour;
  });

  if (hero) setActiveThumb(gallery, heroImg, hero);
}

function openLightbox(src, alt) {
  var lb = document.createElement('div');
  lb.className = 'tsf-lightbox';
  var img = document.createElement('img');
  img.src = src.replace(/width=\d+/, 'width=1600');
  img.alt = alt || '';
  lb.appendChild(img);
  lb.addEventListener('click', function () { document.body.removeChild(lb); });
  document.addEventListener('keydown', function esc(e) {
    if (e.key === 'Escape') { document.body.removeChild(lb); document.removeEventListener('keydown', esc); }
  });
  document.body.appendChild(lb);
}

/* ── Cart Drawer ─────────────────────────────────────────────────────────── */
var cartDrawer     = null;
var cartOverlay    = null;
var cartItemsEl    = null;
var cartSubtotal   = null;
var cartSubLabel   = null;
var cartTrigger    = null; // element that opened the drawer — focus returns here
var cartLastState  = null; // last /cart.js payload, so VAT flips can re-total it

function initCart() {
  cartDrawer   = document.getElementById('tsf-cart-drawer');
  cartOverlay  = document.getElementById('tsf-overlay');
  cartItemsEl  = document.getElementById('tsf-cart-items');
  cartSubtotal = document.getElementById('tsf-cart-subtotal');
  cartSubLabel = document.getElementById('tsf-cart-subtotal-label');
  if (!cartDrawer) return;

  // Open cart
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });

  // Close cart
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Remove items
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    removeCartItem(btn.dataset.cartRemove);
  });

  // Listen for cart updates from SQM
  document.addEventListener('tsf:cart-updated', refreshCart);

  // Escape closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!cartDrawer.classList.contains('is-open')) return;
    closeCart();
  });
}

function openCart() {
  // Fall back to the header cart button when the drawer was opened
  // programmatically (e.g. after add-to-cart), so focus has somewhere to return.
  var active = document.activeElement;
  cartTrigger = (active && active !== document.body && typeof active.focus === 'function')
    ? active
    : document.querySelector('[data-cart-open]');
  refreshCart();
  cartDrawer.classList.add('is-open');
  if (cartOverlay) cartOverlay.hidden = false;
  document.body.style.overflow = 'hidden';

  // Move focus into the drawer so keyboard users land inside it
  var target = cartDrawer.querySelector('[data-cart-close]') || cartDrawer.querySelector('h2');
  if (target) {
    if (!target.hasAttribute('tabindex') && target.tagName !== 'BUTTON') target.setAttribute('tabindex', '-1');
    target.focus();
  }
}

function closeCart() {
  cartDrawer.classList.remove('is-open');
  if (cartOverlay) cartOverlay.hidden = true;
  document.body.style.overflow = '';
  if (cartTrigger && typeof cartTrigger.focus === 'function') cartTrigger.focus();
  cartTrigger = null;
}

function refreshCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
    })
    .catch(function () {});
}

function renderCartItems(cart) {
  cartLastState = cart;
  if (!cartItemsEl) return;
  if (!cart.items.length) {
    cartItemsEl.innerHTML = '<p class="tsf-cart-drawer__empty">Your cart is empty</p>';
    updateCartSubtotal();
    return;
  }

  cartItemsEl.innerHTML = cart.items.map(function (item) {
    return '<div class="tsf-cart-item">' +
      (item.image ? '<img class="tsf-cart-item__img" src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">' : '') +
      '<div class="tsf-cart-item__info">' +
        '<div class="tsf-cart-item__title">' + item.product_title + '</div>' +
        '<div class="tsf-cart-item__variant">' + item.variant_title + ' &times; ' + item.quantity + '</div>' +
        '<div class="tsf-cart-item__price" data-vat-base="' + item.line_price + '" data-vat-taxable="' + (item.taxable !== false) + '">' +
          formatMoney(item.line_price, item.taxable) +
        '</div>' +
        '<button class="tsf-cart-item__remove" data-cart-remove="' + item.key + '">Remove</button>' +
      '</div>' +
    '</div>';
  }).join('');

  updateCartSubtotal();
}

/* Subtotal = sum of each line as it is shown, using that line's own taxable
   status. Children's clothing is zero-rated, so cart.total_price * 1.2 is wrong. */
function updateCartSubtotal() {
  if (!cartSubtotal) return;
  var mode  = localStorage.getItem('tsf-vat') || 'ex';
  var items = (cartLastState && cartLastState.items) || [];
  // A basket of nothing but zero-rated children's wear has no VAT either way,
  // so labelling the subtotal "ex VAT" would contradict itself.
  var anyTaxable = items.some(function (item) { return item.taxable !== false; });

  if (cartSubLabel) {
    cartSubLabel.textContent = !anyTaxable ? 'Subtotal'
      : (mode === 'inc') ? 'Subtotal (inc VAT)' : 'Subtotal (ex VAT)';
  }

  if (!items.length) {
    cartSubtotal.textContent = '';
    return;
  }

  var total = cartLastState.items.reduce(function (sum, item) {
    var taxable = item.taxable !== false;
    return sum + ((mode === 'inc' && taxable) ? Math.round(item.line_price * 1.2) : item.line_price);
  }, 0);

  cartSubtotal.textContent = '£' + (total / 100).toFixed(2);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
    el.hidden = count === 0;
  });
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
    });
}

function formatMoney(cents, taxable) {
  var mode = localStorage.getItem('tsf-vat') || 'ex';
  var amount = (mode === 'inc' && taxable !== false) ? cents * 1.2 : cents;
  return '£' + (amount / 100).toFixed(2);
}

/* ── Header search ───────────────────────────────────────────────────────── */
function initSearch() {
  var searchBtn = document.getElementById('tsf-search-btn');
  var searchBar = document.getElementById('tsf-search-bar');
  if (!searchBtn || !searchBar) return;
  searchBtn.addEventListener('click', function () {
    var open = searchBar.classList.toggle('is-open');
    if (open) searchBar.querySelector('input').focus();
  });
}

/* ── Mobile nav ──────────────────────────────────────────────────────────── */
function initMobileNav() {
  var menuBtn = document.getElementById('tsf-menu-btn');
  var nav     = document.getElementById('tsf-main-nav');
  if (!menuBtn || !nav) return;

  menuBtn.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', open);
  });

  // Close mobile nav when a link is clicked
  nav.addEventListener('click', function (e) {
    if (e.target.tagName === 'A' && window.innerWidth <= 989) {
      nav.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // Close mobile nav when clicking outside
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 989) return;
    if (!nav.contains(e.target) && !menuBtn.contains(e.target)) {
      nav.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // Tap mega menu trigger on mobile
  nav.addEventListener('click', function (e) {
    var trigger = e.target.closest('.tsf-megamenu-trigger');
    if (!trigger) return;
    if (window.innerWidth > 989) return;
    e.preventDefault();
    var item = trigger.closest('.tsf-has-megamenu');
    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open);
  });

  // Category groups are accordions inside the drawer. On desktop the CSS keeps
  // every column open, so this only ever matters at drawer widths.
  nav.addEventListener('click', function (e) {
    var title = e.target.closest('.tsf-megamenu__col-title');
    if (!title) return;
    if (window.innerWidth > 989) return;
    title.setAttribute('aria-expanded', title.getAttribute('aria-expanded') !== 'true');
  });
}

/* ── Mega menu (desktop hover with grace-period delay) ───────────────────── */
function initMegaMenus() {
  document.querySelectorAll('.tsf-has-megamenu').forEach(function (item) {
    var timer = null;
    var trigger = item.querySelector('.tsf-megamenu-trigger');

    function setState(open) {
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open);
    }

    function openMenu() {
      clearTimeout(timer);
      document.querySelectorAll('.tsf-has-megamenu.is-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        var t = other.querySelector('.tsf-megamenu-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      setState(true);
    }

    function closeMenu() {
      timer = setTimeout(function () { setState(false); }, 120);
    }

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);

    // Keyboard: tabbing into the item opens it, tabbing out of it closes it.
    // Only above the drawer breakpoint — in the drawer the panel is toggled
    // by tapping the trigger, and opening on focus would fight that.
    item.addEventListener('focusin', function () {
      if (window.innerWidth > 989) openMenu();
    });
    item.addEventListener('focusout', function (e) {
      if (window.innerWidth <= 989) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      clearTimeout(timer);
      setState(false);
    });

    // A <button> trigger has no href, so clicking it must do the opening.
    //
    // It must never do the CLOSING while the pointer is still on it. Moving the
    // mouse to the trigger already fired mouseenter and opened the panel, so a
    // plain toggle would shut the panel the instant the visitor clicked the
    // thing they were aiming at — which reads as "the menu does nothing".
    // Hovering therefore always opens; only a keyboard or touch activation,
    // where there is no hover, toggles.
    if (trigger && trigger.tagName === 'BUTTON') {
      trigger.addEventListener('click', function () {
        if (window.innerWidth <= 989) return;   // drawer handler owns this
        var hovering = false;
        try { hovering = item.matches(':hover'); } catch (e) { hovering = false; }
        if (!hovering && item.classList.contains('is-open')) { clearTimeout(timer); setState(false); }
        else { openMenu(); }
      });
    }

    var menu = item.querySelector('.tsf-megamenu');
    if (menu) {
      menu.addEventListener('mouseenter', function () { clearTimeout(timer); });
      menu.addEventListener('mouseleave', closeMenu);
    }
  });

  function closeAllMegaMenus() {
    document.querySelectorAll('.tsf-has-megamenu.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('.tsf-megamenu-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tsf-has-megamenu')) closeAllMegaMenus();
  });

  // Escape closes, and puts focus back on the trigger it came from.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tsf-has-megamenu.is-open');
    if (!open) return;
    var trigger = open.querySelector('.tsf-megamenu-trigger');
    closeAllMegaMenus();
    if (trigger && open.contains(document.activeElement)) trigger.focus();
  });
}

/* ── Regular dropdowns ───────────────────────────────────────────────────────
   A dropdown whose parent has a real page keeps its <a> and opens on hover
   alone. A parent with no page of its own is a <button class="tsf-dropdown-
   trigger">, which hover cannot reach on a touch screen, so clicking it toggles
   .is-open on the wrapper. Inside the mobile drawer the CSS keeps every
   dropdown expanded, so there is nothing for the click to do there. */
function initDropdowns() {
  function closeAllDropdowns(except) {
    document.querySelectorAll('.tsf-has-dropdown.is-open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var t = d.querySelector('.tsf-dropdown-trigger');
      if (t && t.tagName === 'BUTTON') t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.tsf-has-dropdown').forEach(function (item) {
    var trigger = item.querySelector('.tsf-dropdown-trigger');
    if (!trigger || trigger.tagName !== 'BUTTON') return;

    trigger.addEventListener('click', function () {
      if (window.innerWidth <= 989) return;   // drawer shows the list already
      var open = !item.classList.contains('is-open');
      closeAllDropdowns(item);
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Tabbing out of the item closes it again.
    item.addEventListener('focusout', function (e) {
      if (window.innerWidth <= 989) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tsf-has-dropdown')) closeAllDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tsf-has-dropdown.is-open');
    if (!open) return;
    var trigger = open.querySelector('.tsf-dropdown-trigger');
    var inside  = open.contains(document.activeElement);
    closeAllDropdowns();
    if (trigger && inside && typeof trigger.focus === 'function') trigger.focus();
  });
}

/* ── Colour swatches ─────────────────────────────────────────────────────── */
function initSwatches() {
  document.querySelectorAll('.tsf-swatches').forEach(function (swatches) {
    swatches.addEventListener('click', function (e) {
      var btn = e.target.closest('.tsf-swatch');
      if (!btn) return;
      swatches.querySelectorAll('.tsf-swatch').forEach(function (b) {
        b.classList.toggle('tsf-swatch--active', b === btn);
      });
      var label = swatches.querySelector('.tsf-swatches__current');
      if (label) label.textContent = btn.dataset.colour;
      document.dispatchEvent(new CustomEvent('colour:change', {
        detail: { productId: swatches.dataset.productId, colour: btn.dataset.colour }
      }));
    });
  });
}

/* ── VAT toggle ──────────────────────────────────────────────────────────── */
function initVatToggle() {
  var toggle = document.querySelector('.tsf-vat-toggle');
  if (!toggle) return;
  var mode = localStorage.getItem('tsf-vat') || 'ex';
  applyVat(mode);

  toggle.addEventListener('click', function () {
    mode = (mode === 'ex') ? 'inc' : 'ex';
    localStorage.setItem('tsf-vat', mode);
    applyVat(mode);
    document.dispatchEvent(new CustomEvent('sqm:rebuilt'));
  });

  document.addEventListener('sqm:rebuilt', function () { applyVat(mode); });
}

function applyVat(mode) {
  var toggle = document.querySelector('.tsf-vat-toggle');
  if (toggle) {
    toggle.querySelector('[data-vat-ex]').classList.toggle('tsf-vat-toggle__label--active', mode === 'ex');
    toggle.querySelector('[data-vat-inc]').classList.toggle('tsf-vat-toggle__label--active', mode === 'inc');
  }
  document.querySelectorAll('[data-vat-base]').forEach(function (el) {
    var base    = parseFloat(el.dataset.vatBase) || 0;
    var taxable = el.dataset.vatTaxable !== 'false';
    var amount  = base;
    if (mode === 'inc') {
      // data-vat-inc is a pre-computed inc-VAT figure, for totals that mix
      // taxable and zero-rated lines and so cannot just be multiplied.
      amount = (el.dataset.vatInc !== undefined) ? parseFloat(el.dataset.vatInc)
             : (taxable ? base * 1.2 : base);
    }
    el.textContent = '£' + (amount / 100).toFixed(2);
  });

  // Per-price "ex VAT" / "inc VAT" tags. Only rendered next to prices that
  // actually carry VAT (see size-quantity-selector.liquid), so a zero-rated
  // size never gets one.
  document.querySelectorAll('[data-vat-suffix]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'inc VAT' : 'ex VAT';
  });

  document.querySelectorAll('[data-vat-note]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'Prices shown inc VAT' : 'Prices shown ex VAT';
  });

  document.querySelectorAll('[data-vat-subtotal-label]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'Subtotal (inc VAT)' : 'Subtotal (ex VAT)';
  });

  updateCartSubtotal();
}

/* ── Cart page: quantities save themselves ───────────────────────────────────
   Changing a quantity on the cart page submits the cart form after a short
   pause, using the "update" button so Shopify updates the cart and returns to
   /cart. The page reload is what keeps the summary figures, the header count
   and the drawer in step, so there is nothing to recalculate here and no way
   to loop (a fresh page fires no input event). The checkout button is never
   the submitter. With JavaScript off, "Update cart" still does the same job. */
function initCartPageAutoUpdate() {
  var form = document.getElementById('tsf-cart-form');
  if (!form) return;
  var updateBtn = form.querySelector('[data-cart-update]');
  var timer = null;
  var submitting = false;

  form.addEventListener('input', function (e) {
    if (!e.target || e.target.name !== 'updates[]') return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (submitting) return;
      submitting = true;
      form.classList.add('is-updating');
      if (updateBtn && typeof form.requestSubmit === 'function') {
        form.requestSubmit(updateBtn);
      } else {
        // Fallback: a plain POST of updates[] still updates the cart. It is
        // only reached if requestSubmit is missing, and never sends "checkout".
        form.submit();
      }
    }, 700);
  });

  // Enter inside a quantity box should update, not check out.
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target || e.target.name !== 'updates[]') return;
    e.preventDefault();
    clearTimeout(timer);
    if (submitting) return;
    submitting = true;
    form.classList.add('is-updating');
    if (updateBtn && typeof form.requestSubmit === 'function') form.requestSubmit(updateBtn);
    else form.submit();
  });
}

/* ── Back to top ─────────────────────────────────────────────────────────── */
function initBackToTop() {
  var btn = document.getElementById('tsf-back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.hidden = window.scrollY < 400;
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/* ── Init ────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  initGalleries();
  initCart();
  initSearch();
  initMobileNav();
  initMegaMenus();
  initDropdowns();
  initSwatches();
  initVatToggle();
  initCartPageAutoUpdate();
  initBackToTop();
  refreshCart();
});
